import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PaymentPulseLanding from "@/components/PaymentPulseLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PaymentPulseLanding />} />
          <Route path="*" element={<PaymentPulseLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
